export const REQUEST_AFFILIATE = 'agent/REQUEST_AFFILIATE';
export const SET_AFFILIATE = 'agent/SET_AFFILIATE';
export const SET_AGENT_ID = 'agent/SET_AGENT_ID';
export const RESET_AGENT_ID = 'agent/RESET_AGENT_ID';
